import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Info, AlertTriangle, MapPin, Clock, TrendingUp } from "lucide-react"

export function LeakInfoModal() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="size-8 p-0">
          <Info className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="size-5 text-destructive" />
            Active Leak Information
          </DialogTitle>
          <DialogDescription>Current leak alerts and important notes</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 bg-destructive/5 rounded-lg border border-destructive/20">
              <AlertTriangle className="size-5 text-destructive mt-0.5" />
              <div className="flex-1">
                <h4 className="font-medium text-sm">High Priority Leaks</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  These leaks require immediate attention due to high water loss rates or critical
                  location.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
              <Clock className="size-5 text-primary mt-0.5" />
              <div className="flex-1">
                <h4 className="font-medium text-sm">Detection Time</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Leaks are detected in real-time using advanced AI algorithms analyzing flow
                  patterns and pressure anomalies.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
              <MapPin className="size-5 text-primary mt-0.5" />
              <div className="flex-1">
                <h4 className="font-medium text-sm">Location Tracking</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Each leak is geo-located to help dispatch teams quickly. View detailed location on
                  the devices page.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
              <TrendingUp className="size-5 text-primary mt-0.5" />
              <div className="flex-1">
                <h4 className="font-medium text-sm">Response Metrics</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Average response time: 2.5 hours. Resolution rate: 95% within 24 hours.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t pt-4">
            <h4 className="font-medium text-sm mb-2">Important Notes</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                <span>
                  Active leaks are automatically synced from smart water meters every 15 minutes
                </span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                <span>
                  Customers are notified immediately via email and SMS when a leak is detected
                </span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                <span>
                  Historical leak data is retained for 12 months for analysis and reporting
                </span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary">•</span>
                <span>
                  False positive rate is less than 2% thanks to multi-parameter validation
                </span>
              </li>
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
